import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "reference-user__header" }
const _hoisted_2 = { class: "reference-user__item" }
const _hoisted_3 = { class: "reference-user__left" }
const _hoisted_4 = { class: "reference-user__right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_BasicCheckbox = _resolveComponent("BasicCheckbox")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_ReferenceComponentParentList = _resolveComponent("ReferenceComponentParentList")!

  return (_openBlock(), _createBlock(_component_ReferenceComponentParentList, {
    searchList: _ctx.result,
    componentType: _ctx.componentType,
    selectedIndex: _ctx.selectedIndex,
    command: _ctx.command,
    isLast: _ctx.isLast,
    class: "reference-user",
    onOnClick: _ctx.onClick,
    onOnScroll: _ctx.onScroll
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_BaseSubHeading, {
          weight: "600",
          size: "large",
          color: "monochrome-06",
          className: "reference-user__title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Team ")
          ]),
          _: 1
        }),
        (_ctx.showTaskOwnersFilter)
          ? (_openBlock(), _createBlock(_component_BasicCheckbox, {
              key: 0,
              label: "Task owners only",
              value: "taskOwnersOnly",
              modelValue: _ctx.isTaskOwnersOnly,
              checkType: "switch",
              "onUpdate:modelValue": _ctx.handleCheckbox
            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
          : _createCommentVNode("", true)
      ])
    ]),
    item: _withCtx(({ option }) => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Avatar, {
            src: option.pictureUrl,
            gap: option.getInitials()
          }, null, 8, ["src", "gap"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_BaseSubHeading, {
            weight: "400",
            size: "large",
            color: "monochrome-06",
            className: "reference-user__title"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(option.fullName), 1)
            ]),
            _: 2
          }, 1024),
          (_ctx.hasDuplicateName(option.fullName))
            ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
                key: 0,
                weight: "500",
                size: "medium",
                color: "monochrome-05",
                darkColor: "monochrome-04",
                className: "reference-user__desc"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" (" + _toDisplayString(option.email) + ") ", 1)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["searchList", "componentType", "selectedIndex", "command", "isLast", "onOnClick", "onOnScroll"]))
}